import cn from 'clsx'

import css from './youtube-embed.module.css'

export type Props = {
    youtubeId: string
    className?: string
}

function YoutubeEmbed({ youtubeId, className }: Props) {
    return (
        <div className={cn(css.videoWrapper, className)}>
            <iframe
                src={`https://www.youtube-nocookie.com/embed/${youtubeId}`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        </div>
    )
}

export { YoutubeEmbed }
